import { request } from './http';

export async function testSchedulerGeneration() {
    return request('/scheduler/debug/test-generation', {
      method: 'POST'
    });
  }

export async function checkSchedulerDatabase() {
    return request('/scheduler/debug/database-check');
  }

export async function getFormStatusesDueToday() {
    return request('/scheduler/form-statuses-due-today');
  }

export async function getSchedulerUpcomingWeek(days = 7) {
    return request(`/scheduler/upcoming-week?days=${encodeURIComponent(days)}`);
  }

export async function getFormStatusHealth() {
    return request('/scheduler/form-status-health');
  }

export async function generateFormStatusRecords() {
    return request('/scheduler/generate-form-status-records', {
      method: 'POST'
    });
  }

export async function generateFlowMeterLogRecords() {
    return request('/scheduler/generate-flow-meter-log-records', {
      method: 'POST'
    });
  }

export async function generateEquipmentServiceLogRecords() {
    return request('/scheduler/generate-equipment-service-log-records', {
      method: 'POST'
    });
  }

export async function generateAllRecordGenerationTasks() {
    return request('/scheduler/generate-all-records', {
      method: 'POST'
    });
  }

export async function repairFormStatusInspectionRaci(formStatusIds = null) {
    const body = Array.isArray(formStatusIds) && formStatusIds.length > 0
      ? { formStatusIds }
      : {};
    return request('/scheduler/repair-form-status-inspection-raci', {
      method: 'POST',
      body: JSON.stringify(body)
    });
  }

export async function diagnoseHomeQueueFormStatusRecords(email, formStatusIds = null) {
    const params = new URLSearchParams();
    if (email) params.set('email', email);
    if (Array.isArray(formStatusIds) && formStatusIds.length > 0) {
      params.set('formStatusIds', formStatusIds.join(','));
    }
    const query = params.toString();
    return request(`/scheduler/debug/home-queue-form-status-check${query ? `?${query}` : ''}`);
  }

export async function getQaCatalog(siteId) {
    return request(`/qa/catalog?siteId=${encodeURIComponent(siteId)}`);
  }

export async function getQaFormStatuses(siteId) {
    return request(`/qa/form-statuses?siteId=${encodeURIComponent(siteId)}`);
  }

export async function generateQaRecords(payload) {
    return request('/qa/generate', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function getQaBatches({ siteId, mine = false } = {}) {
    const params = new URLSearchParams();
    if (mine) params.set('mine', '1');
    if (siteId != null && siteId !== '') params.set('siteId', siteId);
    const query = params.toString();
    return request(`/qa/batches${query ? `?${query}` : ''}`);
  }

export async function getQaOpenRecord(tableName, siteId) {
    const params = new URLSearchParams();
    params.set('tableName', tableName);
    params.set('siteId', siteId);
    return request(`/qa/open-record?${params.toString()}`);
  }

export async function verifyQaRecord(payload) {
    return request('/qa/verify', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export async function cleanupQaBatch(batchId) {
    return request(`/qa/batches/${encodeURIComponent(batchId)}/cleanup`, {
      method: 'POST'
    });
  }

export async function cleanupQaSite(siteId) {
    return request('/qa/batches/cleanup-site', {
      method: 'POST',
      body: JSON.stringify({ siteId })
    });
  }

export async function cleanupQaMine() {
    return request('/qa/batches/cleanup-mine', {
      method: 'POST'
    });
  }

export async function getQaRecordAccess(tableName, recordId) {
    const params = new URLSearchParams();
    params.set('tableName', tableName);
    params.set('recordId', recordId);
    return request(`/qa/record-access?${params.toString()}`);
  }

export async function checkQaRecordAccess(payload) {
    return request('/qa/record-access/check', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

export const schedulerDebugMethodsApi = {
  testSchedulerGeneration,
  checkSchedulerDatabase,
  getFormStatusesDueToday,
  getSchedulerUpcomingWeek,
  getFormStatusHealth,
  generateFormStatusRecords,
  generateFlowMeterLogRecords,
  generateEquipmentServiceLogRecords,
  generateAllRecordGenerationTasks,
  repairFormStatusInspectionRaci,
  diagnoseHomeQueueFormStatusRecords,
  getQaCatalog,
  getQaFormStatuses,
  generateQaRecords,
  getQaBatches,
  getQaOpenRecord,
  verifyQaRecord,
  cleanupQaBatch,
  cleanupQaSite,
  cleanupQaMine,
  getQaRecordAccess,
  checkQaRecordAccess,
};

